<template>
  <div>
    <!-- <div class="row justify-content-between align-items-center">
      <div class="col-md-2 customHeading">
        <h3>{{ moduleName }}</h3>
      </div>
      <div class="col-md-2">
        <b-form-group
          label=""
          label-for="datepicker-2"
          autocomplete="off"
          style="margin-bottom: 0px;"
        >
          <b-form-datepicker
            id="datepicker-2"
            v-model="FromDate"
            @input="getWheatReceives()"
            placeholder="Choose Start Date"
            local="en"
          ></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="col-md-2">
        <b-form-group
          label=""
          style="margin-bottom: 0px;"
          label-for="datepicker-1"
          autocomplete="off"
        >
          <b-form-datepicker
            id="datepicker-1"
            v-model="ToDate"
            placeholder="Choose End Date"
            @input="getWheatReceives()"
            local="en"
          ></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="col-md-1">
        <b-form-select
          v-model="IsGovt"
          :options="statusOptions"
          class="class-dropdown"
          @change="getWheatReceives()"
        ></b-form-select>
      </div>
      <div class="col-md-1">
        <b-form-select
          v-model="IsNonInventory"
          :options="inventoryOptions"
          class="class-dropdown"
          @change="getWheatReceives()"
        ></b-form-select>
      </div>
      <div class="col-md-1">
        <b-form-select
          v-model="wheatTypeId"
          :options="wheatTypes"
          class="class-dropdown"
          @change="getWheatTypes()"
        ></b-form-select>
      </div>

      <div class="col-md-3">
        <div class="searchbox input-group" role="group">
          <input
            class="form-control search-box my-search-box"
            type="text"
            placeholder=" Search By Voucher No"
            aria-label="search"
            v-model="filteredText"
          />

          <button
            class="search-button btn btn-primary filter"
            @click="getWheatReceives()"
          >
            <i class="fa fa-search search-icon"></i>
          </button>
        </div>
      </div>
      <div class="col-md-1 Add-button" style="text-align:center">
        <a href="javascript:void(0)">
          <div class="AddButton">
            <div class="icon">
              <i
                class="fas fa-arrow-alt-circle-right fa-1x"
                style="color: rgb(255, 50, 55);"
              >
              </i>
            </div>
            <div
              data-text="Add"
              class="name add-btn"
              v-b-modal.AddWheatReceivedModal
            >
              Add
            </div>
          </div>
        </a>
      </div>

      
        <div class="col-md-6"><div class="icons_group"><div class="row w3-center"><div class="col-md-2"><a href="#filterSection" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="filterSection"><div class="icon"><i class="fas fa-align-center fa-1x" style="color: rgb(243, 0, 104);"></i></div> <div data-text="Filter" class="name">Filter</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-check-circle fa-1x" style="color: rgb(149, 171, 184);"></i></div> <div data-text="Anti-Spam" class="name">Anti-Spam</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-stream fa-1x" style="color: rgb(255, 143, 38);"></i></div> <div data-target="Autoresponder" class="name">
                                  Auto-responder
        </div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);"></i></div> <div data-text="Forward" class="name">Forward</div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-trash fa-1x" style="color: rgb(195, 0, 0);"></i></div> <div data-text="delete" class="name">Delete</div></a></div></div></div></div>
       
      
    </div> -->

    <div class="">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <!-- <div class="col-md-2 customHeading">
            <h3>{{ moduleName }}</h3>
          </div> -->
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <!-- <div class="custom-btn">
                <div class="btn-group custom-btn-group">
                  <button
                    class="btn custom-dropdown-btn btn-md dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <b-icon class="icon" icon="menu-button-wide"></b-icon>

                    Issues
                    <b-icon
                      class="custom-arrow-icon"
                      icon="chevron-down"
                    ></b-icon>
                  </button>
                  <div class="dropdown-menu">
                    <button class="dropdown-item" type="button">Action</button>
                    <button class="dropdown-item" type="button">
                      Another action
                    </button>
                    <button class="dropdown-item" type="button">
                      Something else here
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Options"
              >
                <a href="#">
                  <div class="icon">
                    <b-icon icon="sliders"></b-icon>

                  </div>

                </a>
              </div> -->
              <!---SEARCH BAR--->
              <div class="mr-md-2 custom-search-input-filter">
                <div class="input-group custom-input-group-filter">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text custom-input-group-icon pointer"
                      id="basic-search"
                      ><b-icon icon="Search" @click="getWheatReceives"></b-icon
                    ></span>
                  </div>
                  <input
                    type="text"
                    class="form-control custom-filter-input form-control-sm"
                    placeholder="Search By Voucher No"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model.trim="filteredText"
                    @keyup="getWheatReceives"
                    @keydown.enter.prevent="getWheatReceives"
                  />
                </div>
              </div>

              <!-- <div class="searchbox input-group" role="group">
                <input
                  class="form-control search-box my-search-box"
                  type="text"
                  placeholder=" Search By Voucher No"
                  aria-label="search"
                  v-model="filteredText"
                />

                <button
                  class="search-button btn btn-primary filter"
                  @click="getWheatReceives()"
                >
                  <i class="fa fa-search search-icon"></i>
                </button>
              </div> -->

              <!---ADD BUTTON-->
              <!-- <div class="custom-btn">
                <a href="javascript:void(0)">
                  <div class="AddButton">
                    <div class="icon">
                      <i
                        class="fas fa-arrow-alt-circle-right fa-1x"
                        style="color: rgb(255, 50, 55);"
                      >
                      </i>
                      <plus-icon size="0.8x" class="custom-class"></plus-icon>
                    </div>
                    <div
                      data-text="Add"
                      class="name add-btn"
                      v-b-modal.AddWheatReceivedModal
                    >
                      Add
                    </div>
                  </div>
                </a>
              </div> -->

              <div class="custom-btn">
                <a
                  href="#addorEditModal"
                  data-toggle="modal"
                  title="Add Wheat Receive"
                  v-b-modal.AddWheatReceivedModal
                >
                  <div class="custom-icon icon">
                    <b-icon icon="plus" scale="1.7"></b-icon>
                    <!-- <plus-icon size="0.8x" class="custom-class"></plus-icon> -->
                  </div>
                </a>
              </div>

              <!-- Separator -->
              <div class="custom-btn">
                <div class="custom-icon icon">
                  <span style="font-weight: 300; font-size: 15px">|</span>
                </div>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <a
                  href="#filterSection"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="filterSection"
                >
                  <div class="icon">
                    <b-icon icon="filter" scale="1.7"></b-icon>
                    <!-- <i class="fas fa-align-center fa-1x" style="color: #F30068;"></i> -->
                  </div>
                  <!-- <div class="name" data-text="Filter">Filter</div> -->
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapse" id="filterSection">
        
        <div class="card card-body custom-filter-body">
          <div class="custom-filter-wrap">
            <div class="container-fluid custom-row d-flex justify-content-between">
              
              <!-- <div class="flex-grow-1 pr-2">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text custom-input-group-icon"
                      id="basic-addon1"
                      ><b-icon icon="funnel"></b-icon
                    ></span>
                  </div>
                  <input
                    type="text"
                    class="form-control custom-filter-input"
                    placeholder="Filter by Keyword"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                </div>
              </div> -->

              <div class="custom-filter-column">
                <b-form>
                  <!---CHOOSE START DATE-->

                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                    style="margin-bottom: 0px;"
                  >
                    <b-form-datepicker
                      id="datepicker-2"
                      v-model="FromDate"
                      @input="getWheatReceives()"
                      placeholder="Choose Start Date"
                      local="en"
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                  <!---CHOOSE END DATE-->
                  <b-form-group
                    label=""
                    style="margin-bottom: 0px;"
                    label-for="datepicker-1"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-1"
                      v-model="ToDate"
                      placeholder="Choose End Date"
                      @input="getWheatReceives()"
                      local="en"
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                  <!---CHOOSE WHEAT RECEIVED FROM-->
                  <b-form-select
                    v-model="IsGovt"
                    :options="statusOptions"
                    class="class-dropdown"
                    @change="getWheatReceives()"
                  ></b-form-select>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                  <!---CHOOSE TYPE-->
                  <b-form-select
                    v-model="IsNonInventory"
                    :options="inventoryOptions"
                    class="class-dropdown"
                    @change="getWheatReceives()"
                  ></b-form-select>

                  <!---CHOOSE WHEAT TYPE-->
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                  <!---CHOOSE WHEAT TYPE-->
                  <!-- <b-form-select
                    v-model="wheatTypeId"
                    :options="wheatTypes"
                    class="class-dropdown"
                    @change="getWheatTypes()"
                  ></b-form-select> -->

                  <select
                    class="mb-2 mr-sm-2 mb-sm-0 custom-select-option form-control"
                    v-model="wheatTypeId"
                    @change="getWheatReceives"
                  >
                    <option value="null">Select Wheat Type (All)</option>
                    <option
                      v-for="option in wheatTypes"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </b-form>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>

    <!-- <div class="row">
      <div class="col">
        <hr
          color="#CACACA"
          style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;"
        />
      </div>
    </div> -->

    <div class="">
      <div
        :class="isLoading ? 'spinner-overlay row no-gutters' : 'row no-gutters'"
      >
        <div class="col">
          <table
            class="table table-striped table-borderless cutom-table table-striped table-sm"
            style="font-size: 85%;"
          >
            <thead>
              <tr>
                <th role="columnheader">Creation Date</th>
                <th role="columnheader">Vendor Issue Date</th>
                <th role="columnheader">Received Date</th>
                <th role="columnheader">Voucher No</th>
                <th role="columnheader">Truck No</th>
                <th role="columnheader">Wheat Type</th>
                <th role="columnheader">Inventory/Non Inventory</th>
                <th role="columnheader">No of Sacks</th>
                <th role="columnheader">Wheat Received From</th>
                <th role="columnheader">Wheat(KGs)</th>
                <th role="columnheader">Wheat(TONs)</th>

                <th role="columnheader">Actions</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if="wheatReceives == null">
                <td class="center-td" colspan="11">No Data</td>
              </tr>

              <tr v-else v-for="wheat in wheatReceives" :key="wheat.id">
                <td role="cell">
                  {{ wheat.creationDate | moment("MMM-DD-YYYY") }}
                </td>
                <td>{{ wheat.dateIssued | moment("MMM-DD-YYYY") }}</td>
                <td>{{ wheat.dateReceived | moment("MMM-DD-YYYY") }}</td>
                <td>{{ wheat.voucherNo }}</td>
                <td>{{ wheat.truckNo }}</td>
                <td>{{ wheat.wheatType.name }}</td>
                <td>
                  {{ wheat.isNonInventory ? "NonInventory" : "Inventory" }}
                </td>
                <td>{{ wheat.noOfSacks }}</td>

                <td>{{ wheat.isGovt ? "Govt" : "Private" }}</td>
                <td>{{ wheat.totalWeight }}</td>
                <td>{{ wheat.totalWeight / 1000 }}</td>
                <td>
                  <span v-if="!wheat.isVerified" @click="verify(wheat.id)">
                    <i
                      role="button"
                      title="Verify Now"
                      style="color:green"
                      class="fa fa-check-circle"
                    ></i>
                  </span>
                  <span v-if="wheat.isVerified">
                    <i
                      title="Verified"
                      style="color:green"
                      class="fa fa-check"
                    ></i>
                  </span>

                  <span
                    v-if="
                      !wheat.isVerified ||
                        $auth.user().role == 'Admin' ||
                        $auth.user().role == 'Manager'
                    "
                    @click="passRecordToEdit(wheat)"
                  >
                    &nbsp;|&nbsp;<i
                      role="button"
                      title="Edit"
                      style="color:green"
                      class="far fa-edit"
                    ></i>
                  </span>
                  <span
                    v-if="
                      !wheat.isVerified ||
                        $auth.user().role == 'Admin' ||
                        $auth.user().role == 'Manager'
                    "
                    @click="passRecordToDelete(wheat.id)"
                  >
                    &nbsp;|&nbsp;<i
                      role="button"
                      title="Delete"
                      style="color:green"
                      class="far fa-trash-alt"
                    ></i>
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="7"></td>
                <td>
                  <b>Total Sacks: {{ totalSacks != null ? totalSacks : 0 }}</b>
                </td>
                <td></td>
                <td>
                  <b>Total: {{ totalKgs != null ? totalKgs : 0 }}</b>
                </td>
                <td>
                  <b>Total: {{ totalTons != null ? totalTons : 0 }}</b>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--PAGINATION START-->
      <div class="container-fluid mb-3">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-2 col-sm-12">
            <div class="showPages">
              <select
                class="form-control"
                id="selClass"
                v-model="perPage"
                @change="getWheatReceives()"
              >
                <option
                  v-for="option in options"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-8 col-sm-12 d-flex justify-content-center">
            <div class="overflow-auto">
              <b-pagination
                class="col-sm-12"
                v-model="page"
                :total-rows="rows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                @change="getPage"
              ></b-pagination>
            </div>
          </div>

          <div class="col-md-2 col-sm-12">
            <input
              class="form-control search-box page-no-search"
              type="text"
              v-bind:placeholder="page"
              aria-label="search"
              v-model.number="pageNumOnSearch"
              style="height:38px"
            />

            <button
              class="search-button btn btn-primary search page-no-search-btn"
              @click="search()"
            >
              GO
            </button>
          </div>
        </div>
      </div>
      <!--/PAGINATION END-->
      <!--SPINNER-->

      <Spinner
        class="spinner"
        v-if="isLoading"
        message="Loading..."
        size="medium"
        line-fg-color="rgb(222 224 219"
        line-bg-color="rgb(68 66 62)"
      >
      </Spinner>
      <!--/SPINNER-->
    </div>
    <AddWheatReceivedModal />
    <DeleteModal
      :msgForModal="msgForModal"
      :apiEndPoint="apiEndPoint"
      :heading="deleteModalHeading"
      :entityId="wheatToDelete"
    />
    <EditWheatReceiveModal :wheatReceive="wheatToEdit" />
    <Toaster ref="toaster" />
  </div>
</template>

<script>
import axios from "axios";
// import config from '../config.js';
import Spinner from "vue-simple-spinner";
import AddWheatReceivedModal from "./modals/AddWheatReceivedModal";
import DeleteModal from "../../modals/DeleteModal";
import EditWheatReceiveModal from "./modals/EditWheatReceiveModal";
import Toaster from "../toaster";
export default {
  name: "WheatReceives",
  data() {
    return {
      moduleName: "Wheat Receives",
      Id: null,
      CompanyName: "",
      Address: null,
      PhoneNumber: null,

      totalKgs: null,
      totalSacks: null,
      totalTons: null,

      isLoading: false,
      wheatToEdit: null,
      wheatToDelete: null,
      msgForModal: null,
      apiEndPoint: null,
      deleteModalHeading: null,
      statusOptions: [
        { value: null, text: "Wheat Received From (All)" },
        { value: true, text: "Govt" },
        { value: false, text: "Private" },
      ],
      inventoryOptions: [
        { value: null, text: "Product Type (All)" },
        { value: false, text: "Inventory" },
        { value: true, text: "Non Inventory" },
      ],

      wheatReceives: null,
      wheatTypes: null,
      IsGovt: null,
      ToDate: null,
      FromDate: null,
      IsNonInventory: null,
      selectedStatus: 1,
      wheatTypeId: null,
      pageNumOnSearch: "",
      filteredText: "",
      rows: 0,
      page: 1,
      options: [
        { text: "Show 2", value: 2 },
        { text: "Show 10", value: 10 },
        { text: "Show 25", value: 25 },
        { text: "Show 50", value: 50 },
        { text: "Show 100", value: 100 },
      ],
      perPage: 25,
    };
  },

  methods: {
    getPage(page) {
      this.page = page;
      this.getWheatReceives();
    },

    verify(id) {
      axios
        .get("/WheatReceives/Verify/" + id)
        .then((res) => {
          if (res.data.status == 1) {
            this.$refs.toaster.showToast(
              "Success",
              "success",
              "Wheat entry has been verified successfully"
            );

            this.getWheatReceives();
          }
          this.$refs.toaster.showToast("Error", "danger", res.data.msg);
        })
        .catch((err) => {
          console.warn("error during http call", err);
        });
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      this.editWheatRec();
    },

    passRecordToDelete(id) {
      this.wheatToDelete = id;
      this.msgForModal = "Confirm to delete !";
      this.apiEndPoint = "WheatReceives/Delete/";
      this.deleteModalHeading = "Delete";
      this.$bvModal.show("DeleteModal");
    },
    passRecordToEdit(wheat) {
      this.wheatToEdit = wheat;
      setTimeout(() => {
        this.$bvModal.show("EditWheatReceiveModal");
      }, 150);

      // console.log(this.companyToEdit)
    },
    getWheatReceives() {
      this.isLoading = true;
      console.log(this.IsGovt);
      if (this.wheatTypeId === "null") {
        this.wheatTypeId = null;
      }
      axios
        .post("/WheatReceives/getall", {
          FromDate: this.FromDate,
          ToDate: this.ToDate,
          CompanyId: this.$auth.user().companyId,
          IsNonInventory: this.IsNonInventory,
          IsGovt: this.IsGovt,
          WheatTypeId: this.wheatTypeId,
          PageSize: this.perPage,
          Page: this.page,
          Text: this.filteredText,
        })
        .then((res) => {
          this.isLoading = false;
          if (res.data.status == 1) {
            this.wheatReceives = res.data.data.records;
            this.totalSacks = res.data.data.totalSacks;
            this.totalKgs = res.data.data.totalKgs;
            this.totalTons = res.data.data.totalTons;
            this.rows = res.data.totalRecords;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          } else {
            this.wheatReceives = null;
          }
        });
    },

    getWheatTypes() {
      this.wheatTypes = null;
      axios
        .post("/wheattype/getAllWheatTypes", {
          CompanyId: this.$auth.user().companyId,
        })
        .then((res) => {
          console.log(res);
          this.wheatTypes = res.data.data;
        });
    },

    search() {
      this.page = this.pageNumOnSearch;
      this.getWheatReceives();
    },
  },
  created() {
    this.getWheatReceives();
    this.getWheatTypes();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components: {
    Spinner,
    AddWheatReceivedModal,
    DeleteModal,
    EditWheatReceiveModal,
    Toaster,
  },
};
</script>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
}
.main-content {
  padding-top: 55px;
}
</style>
